<template>
  <div class="card">
    <v-menu content-class="example-options-content">
      <template #activator="{ props }">
        <v-textarea
          v-bind="{
            ...props,
            onKeyup: undefined,   // Disable default keyup event
            onKeydown: undefined, // Disable default keydown event
            onFocus: props.onFocus, // Only bind focus event if you want menu to open on focus
            onClick: props.onClick // Or bind click event if you want to open on click
          }"
          class="no-border"
          v-model="textModel"
          placeholder="... type here or click to select an example"
          @keyup="changeDescription"
          variant="outlined"
          rows="3"
          :label="label"
          @update:model-value="showExamples = false"
          :autofocus="true"
          ref="textarea"
          :disabled="$store.state.isWorkflowDisabled"
        ></v-textarea>
      </template>

      <v-list>
        <v-list-item v-for="example in examples" :key="example" @click="populateTextarea(example)">
          <v-list-item-title>{{ example }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { workflowDescriptionExamples } from '@/ai/prompts/common/examples'

export default {
  name: 'ExampleTextarea',
  props: {
    label: String,
    text: String
  },
  computed: {
    textModel: {
      get () {
        return this.textModelData
      },
      set (value) {
        this.textModelData = value
      },
      cache: false
    },
    examples () {
      return workflowDescriptionExamples
    }
  },
  data () {
    return {
      textModelData: this.text,
      showExamples: false
      // rules: [v => !!v || 'Required.']
    }
  },
  methods: {
    populateTextarea (example) {
      this.$emit('change-description', { description: example, skipDebounce: true })
      this.textModel = example
      this.showExamples = false
    },

    changeDescription (event) {
      this.$emit('change-description', { description: this.textModel })
    }
  },
  mounted () {
    this.textModel = this.text
  }
}
</script>
<style scoped>

.card {
  width: 100%;
  padding: 0 !important;
  box-shadow: none !important;
}

.no-border .v-input__control .v-field .v-field__outline .v-input__outline::before {
  /* Your styles here */
  border-style: none;
  /* Other styles */
}

.no-border .v-input__control .v-field .v-field__outline .v-input__outline::after {
  /* Your styles here */
  border-style: none;
  /* Other styles */
}

.example-options-content {
  max-height: 250px !important;
}

.no-border :deep(.v-field__outline::before) {
  border-style: none !important;
}
</style>
